export const BRAZIER_COMPLETION_LINES = [
  'The Dark Recedes',
  'Floor Reclaimed',
  'Sanctum Rekindled',
  'The Veil Breaks',
  'The Gloom Withdraws',
  'Embers Defy the Dark',
  'The Circle Burns Whole',
  'Ash Gives Way to Flame',
  'The Rite Stands Complete',
  'Night Yields Its Hold',
  'The Hollow Brightens',
  'Flame Restores the Floor',
  'The Watchfires Answer',
  'The Hall Takes Light',
  'The Shadows Falter',
  'The Seal of Fire Holds',
  'Darkness Loses Ground',
  'The Flame Remembers',
  'The Chamber Breathes Again',
  'The Black Veil Thins',
  'The Last Ember Rises',
  'The Sanctum Holds Fast',
  'The Deep Is Driven Back',
  'The Lantern Rite Endures',
];

export const CLEANSING_COMPLETION_LINES = [
  'Floor Cleansed',
  'No Heartbeats Remain',
  'The Hunt Is Over',
  'Silence Claims the Halls',
  'The Last One Falls',
  'Nothing Living Stirs',
  'Blood Debt Collected',
  'The Hall Falls Still',
  'The Slaughter Ends',
  'None Remain Standing',
  'The Threat Lies Broken',
  'The Killing Is Done',
  'Only Silence Endures',
  'The Floor Takes No Breath',
  'The Dead Keep Counsel',
  'No Malice Yet Walks',
  'Their Clamor Is Buried',
  'The Butchery Is Complete',
  'The Halls Swallow the Noise',
  'Flesh and Fury Are Spent',
  'The Last Cry Has Faded',
  'The Red Work Is Finished',
  'No Witnesses Remain',
  'Silence Inherits the Floor',
];

const pickRandomLine = (pool) =>
  pool[Math.floor(Math.random() * pool.length)];

export const pickBrazierCompletionLine = () =>
  pickRandomLine(BRAZIER_COMPLETION_LINES);

export const pickCleansingCompletionLine = () =>
  pickRandomLine(CLEANSING_COMPLETION_LINES);